"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ListItemAvatar = _interopRequireDefault(require("@material-ui/core/ListItemAvatar"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _useStyle = _interopRequireDefault(require("./useStyle"));

var _helpers = require("../helpers");

var _Hocs = require("../../Hocs");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Legend = function Legend(_ref) {
  var lists = _ref.lists;
  var cls = (0, _useStyle["default"])();
  return /*#__PURE__*/_react["default"].createElement(_List["default"], {
    className: cls.root
  }, lists.map(function (text, i) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: i,
      className: cls.item
    }, /*#__PURE__*/_react["default"].createElement(_ListItemAvatar["default"], {
      className: cls.avatarContainer
    }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      className: cls.avatar
    }, (0, _helpers.addLeadingZero)(i))), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: text
    }));
  }));
};

Legend.propTypes = {
  lists: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
};

var _default = (0, _Hocs.renderListSafely)(Legend);

exports["default"] = _default;